export default "__VITE_ASSET__wkqoLAmI6rTNReW38XrkFA__"